import { Lightning } from '@lightningjs/sdk';
import merge from 'lodash/merge';
import { getInitialStyle, getFocusedStyle, getUnfocusedStyle } from './checkBoxBlock.style';
import { Checkbox } from '../checkbox/checkbox.component';

export class CheckBoxBlock extends Lightning.Component {
  static _template() {
    return merge(
      {
        rect: true,
        Checkbox: {
          type: Checkbox,
        },
        TextWrapper: {
          Title: {},
          Description: {},
        },
        Border: {
          type: Lightning.components.BorderComponent,
        },
      },
      getInitialStyle(),
    );
  }

  _build() {
    this.checked = false;
  }

  set data({ title, description }) {
    this.patch({
      TextWrapper: {
        Title: {
          text: {
            text: title,
          },
        },
        Description: {
          text: {
            text: description,
          },
        },
      },
    });
  }

  set checked(value) {
    this.tag('Checkbox').checked = value;
    this._checked = value;
  }

  get checked() {
    return this._checked;
  }

  _handleEnter() {
    this.checked = !this.checked;

    return false;
  }

  _focus() {
    this.patch(getFocusedStyle());
  }

  _unfocus() {
    this.patch(getUnfocusedStyle());
  }
}
